import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
export type TenantScopeOption = {
  value: TenantScope['kind'];
  label: string;
};
type OptionGroup = {
  label: string;
  options: TenantScopeOption[];
};
const useTenantScopeOptions = () => {
  const $ = _c(98);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "scopes"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("roles", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      value: "read",
      label: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      value: "admin",
      label: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      value: "api_keys",
      label: t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      value: "auth_token",
      label: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      value: "org_settings",
      label: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      value: "write_entities",
      label: t11
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp7);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      value: "onboarding",
      label: t13
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp8);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = {
      value: "onboarding_configuration",
      label: t15
    };
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t(_temp9);
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = {
      value: "manage_webhooks",
      label: t17
    };
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t10 || $[38] !== t12 || $[39] !== t14 || $[40] !== t16 || $[41] !== t18 || $[42] !== t2 || $[43] !== t4 || $[44] !== t6 || $[45] !== t8) {
    t19 = {
      label: "Basic Permissions",
      options: [t2, t4, t6, t8, t10, t12, t14, t16, t18]
    };
    $[37] = t10;
    $[38] = t12;
    $[39] = t14;
    $[40] = t16;
    $[41] = t18;
    $[42] = t2;
    $[43] = t4;
    $[44] = t6;
    $[45] = t8;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t) {
    t20 = t(_temp10);
    $[47] = t;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20) {
    t21 = {
      value: "decrypt_all",
      label: t20
    };
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t) {
    t22 = t(_temp11);
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t22) {
    t23 = {
      value: "decrypt_custom",
      label: t22
    };
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t) {
    t24 = t(_temp12);
    $[55] = t;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t24) {
    t25 = {
      value: "decrypt_document",
      label: t24
    };
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t) {
    t26 = t(_temp13);
    $[59] = t;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t26) {
    t27 = {
      value: "decrypt_document_and_selfie",
      label: t26
    };
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t21 || $[64] !== t23 || $[65] !== t25 || $[66] !== t27) {
    t28 = {
      label: "Decrypt Permissions",
      options: [t21, t23, t25, t27]
    };
    $[63] = t21;
    $[64] = t23;
    $[65] = t25;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t) {
    t29 = t(_temp14);
    $[68] = t;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t29) {
    t30 = {
      value: "manual_review",
      label: t29
    };
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t) {
    t31 = t(_temp15);
    $[72] = t;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t31) {
    t32 = {
      value: "trigger_kyc",
      label: t31
    };
    $[74] = t31;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== t) {
    t33 = t(_temp16);
    $[76] = t;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t33) {
    t34 = {
      value: "trigger_kyb",
      label: t33
    };
    $[78] = t33;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t(_temp17);
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t35) {
    t36 = {
      value: "cip_integration",
      label: t35
    };
    $[82] = t35;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t30 || $[85] !== t32 || $[86] !== t34 || $[87] !== t36) {
    t37 = {
      label: "Compliance Permissions",
      options: [t30, t32, t34, t36]
    };
    $[84] = t30;
    $[85] = t32;
    $[86] = t34;
    $[87] = t36;
    $[88] = t37;
  } else {
    t37 = $[88];
  }
  let t38;
  if ($[89] !== t) {
    t38 = t(_temp18);
    $[89] = t;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  let t39;
  if ($[91] !== t38) {
    t39 = {
      label: "Proxy Permissions",
      options: [{
        value: "manage_vault_proxy",
        label: t38
      }]
    };
    $[91] = t38;
    $[92] = t39;
  } else {
    t39 = $[92];
  }
  let t40;
  if ($[93] !== t19 || $[94] !== t28 || $[95] !== t37 || $[96] !== t39) {
    const options = [t19, t28, t37, t39];
    const tenantScopeFromOption = _temp19;
    t40 = {
      options,
      tenantScopeFromOption
    };
    $[93] = t19;
    $[94] = t28;
    $[95] = t37;
    $[96] = t39;
    $[97] = t40;
  } else {
    t40 = $[97];
  }
  return t40;
};
export default useTenantScopeOptions;
function _temp($) {
  return $.read;
}
function _temp2($_0) {
  return $_0.admin;
}
function _temp3($_1) {
  return $_1.api_keys;
}
function _temp4($_2) {
  return $_2.auth_token;
}
function _temp5($_3) {
  return $_3.org_settings;
}
function _temp6($_4) {
  return $_4.write_entities;
}
function _temp7($_5) {
  return $_5.onboarding;
}
function _temp8($_6) {
  return $_6.onboarding_configuration;
}
function _temp9($_7) {
  return $_7.manage_webhooks;
}
function _temp10($_8) {
  return $_8.decrypt_all;
}
function _temp11($_9) {
  return $_9.decrypt_custom;
}
function _temp12($_10) {
  return $_10.decrypt_documents;
}
function _temp13($_11) {
  return $_11.decrypt_document_and_selfie;
}
function _temp14($_12) {
  return $_12.manual_review;
}
function _temp15($_13) {
  return $_13.trigger_kyc;
}
function _temp16($_14) {
  return $_14.trigger_kyb;
}
function _temp17($_15) {
  return $_15.cip_integration;
}
function _temp18($_16) {
  return $_16.manage_vault_proxy;
}
function _temp19(option) {
  return {
    kind: option
  } as TenantScope;
}